import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.from";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";
import _classCallCheck from "E:\\Works\\Statistic\\stat-app\\node_modules\\@vue\\babel-preset-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "E:\\Works\\Statistic\\stat-app\\node_modules\\@vue\\babel-preset-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "E:\\Works\\Statistic\\stat-app\\node_modules\\@vue\\babel-preset-app\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "E:\\Works\\Statistic\\stat-app\\node_modules\\@vue\\babel-preset-app\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "E:\\Works\\Statistic\\stat-app\\node_modules\\@vue\\babel-preset-app\\node_modules\\@babel\\runtime/helpers/esm/inherits";

/**
 * @license Copyright (c) 2003-2019, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module indent/indentblockcommand
 */
import Command from '@ckeditor/ckeditor5-core/src/command';
import first from '@ckeditor/ckeditor5-utils/src/first';
/**
 * The indent block command.
 *
 * The command is registered by the {@link module:indent/indentblock~IndentBlock} as `'indentBlock'` for indenting blocks and
 * `'outdentBlock'` for outdenting blocks.
 *
 * To increase block indentation at the current selection, execute the command:
 *
 *		editor.execute( 'indentBlock' );
 *
 * To decrease block indentation at the current selection, execute the command:
 *
 *		editor.execute( 'outdentBlock' );
 *
 * @extends module:core/command~Command
 */

var IndentBlockCommand =
/*#__PURE__*/
function (_Command) {
  _inherits(IndentBlockCommand, _Command);

  /**
   * Creates an instance of the command.
   *
   * @param {module:core/editor/editor~Editor} editor The editor instance.
   * @param {module:indent/indentblockcommand~IndentBehavior} indentBehavior
   */
  function IndentBlockCommand(editor, indentBehavior) {
    var _this;

    _classCallCheck(this, IndentBlockCommand);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(IndentBlockCommand).call(this, editor));
    /**
     * The command's indentation behavior.
     *
     * @type {module:indent/indentblockcommand~IndentBehavior}
     * @private
     */

    _this._indentBehavior = indentBehavior;
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(IndentBlockCommand, [{
    key: "refresh",
    value: function refresh() {
      // Check whether any of the position's ancestors is a list item.
      var editor = this.editor;
      var model = editor.model;
      var block = first(model.document.selection.getSelectedBlocks());

      if (!block || !model.schema.checkAttribute(block, 'blockIndent')) {
        this.isEnabled = false;
        return;
      }

      this.isEnabled = this._indentBehavior.checkEnabled(block.getAttribute('blockIndent'));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "execute",
    value: function execute() {
      var _this2 = this;

      var model = this.editor.model;
      var blocksToChange = getBlocksToChange(model);
      model.change(function (writer) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = blocksToChange[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var block = _step.value;
            var currentIndent = block.getAttribute('blockIndent');

            var nextIndent = _this2._indentBehavior.getNextIndent(currentIndent);

            if (nextIndent) {
              writer.setAttribute('blockIndent', nextIndent, block);
            } else {
              writer.removeAttribute('blockIndent', block);
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      });
    }
  }]);

  return IndentBlockCommand;
}(Command); // Returns blocks from selection that should have blockIndent selection set.
//
// @param {module:engine/model/model~model} model A model.


export { IndentBlockCommand as default };

function getBlocksToChange(model) {
  var selection = model.document.selection;
  var schema = model.schema;
  var blocksInSelection = Array.from(selection.getSelectedBlocks());
  return blocksInSelection.filter(function (block) {
    return schema.checkAttribute(block, 'blockIndent');
  });
}
/**
 * Provides indentation behavior to {@link module:indent/indentblockcommand~IndentBlockCommand}.
 *
 * @interface module:indent/indentblockcommand~IndentBehavior
 */

/**
 * Checks if the command should be enabled.
 *
 * @method #checkEnabled
 * @param {String} indentAttributeValue The current indent attribute value.
 * @returns {Boolean}
 */

/**
 * Returns a new indent attribute value based on the current indent. This method returns `undefined` when the indentation should be removed.
 *
 * @method #getNextIndent
 * @param {String} indentAttributeValue The current indent attribute value.
 * @returns {String|undefined}
 */